import { Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next"; 
import Dialog from "./Dialog";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Button } from "../controls";
import { useState } from "react";

const AlertIcon = ({ alert }) => {
  switch (alert.type) {
    case "success":
      return <CheckCircleRoundedIcon color={alert.type} className="fs-70" />;
    case "warning":
      return <WarningAmberRoundedIcon color={alert.type} className="fs-70" />;
    case "error":
      return <ErrorOutlineRoundedIcon color={alert.type} className="fs-70" />;
    case "info":
      return <InfoOutlinedIcon color={alert.type} className="fs-70" />;
    default:
      break;
  }
};

const AlertTextIcon = ({ alert }) => {
  return (
    <>
      <Grid className="mt-30 mb-20">
        <AlertIcon {...{ alert }} />
      </Grid>
      <Grid className="gray-color">
        <p className="fs-22 mt-0 mb-0 fw-6">{alert.title}</p>
        <p className="p mt-10 pl-30 pr-30">{alert.subTitle}</p>
      </Grid>
    </>
  );
};

const ConfirmationCom = (props) => {
  const { alert, setAlert } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Grid
        container
        direction="column"
        sx={{
          position: "relative",
          textAlign: "center",
        }}
      >
        <AlertTextIcon alert={{ ...alert, type: "error" }} />
        <Grid className="p-10 mb-10">
          <Button
            className="fs-16 m-5 w-100 shadow-none"
            variant="contained"
            color="error"
            loading={loading}
            onClick={() => {
              setLoading(true);
              alert.onConfirm && alert.onConfirm();
            }}
          >
            {alert.confirmBtnTitle ? alert.confirmBtnTitle : t("yes")}
          </Button>
          <Button
            className="fs-16 m-5 min-w-120 shadow-none"
            variant="contained"
            loading={loading}
            onClick={() =>
              alert.onCancel !== undefined
                ? alert.onCancel
                : setAlert({ ...alert, isOpen: false })
            }
          >
            {alert.cancelBtnTitle ? alert.cancelBtnTitle : t("cancel")}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default function Alert(props) {
  const { alert, setAlert } = props;
  const { t } = useTranslation();

  return (
    <>
      {alert && (
        <Dialog show={alert.isOpen} maxWidth="xs">
          {alert.type === "confirmation" ? (
            <ConfirmationCom {...{ alert, setAlert }} />
          ) : (
            <Grid
              container
              direction="column"
              sx={{
                position: "relative",
                textAlign: "center",
              }}
            >
              <AlertTextIcon {...{ alert }} />
              <Grid className="mt-20 p-10">
                <Button
                  className="font-18 fw-6"
                  variant="contained"
                  sx={{ boxShadow: "none" }}
                  color={alert.type !== "" ? alert.type : "primary"}
                  fullWidth
                  onClick={() => {
                    setAlert({ ...alert, isOpen: false });
                    alert.onClick && alert.onClick();
                  }}
                >
                  {t("ok")}
                </Button>
              </Grid>
            </Grid>
          )}
        </Dialog>
      )}
    </>
  );
}
